/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/19/20
 * Time: 11:21 AM
 */
import React,{Component} from 'react';
import '../ManageCamera.scss';
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn, Dropdown} from "semantic-ui-react";
import Download from "../../../../../components/Button/DownloadbleButton";
import {MDBDataTable} from "mdbreact";
import * as tableHeaders from "../../../../../const/table/TableHeaders";
import Cookies from "js-cookie";
import axiosVisitortags from "../../../../../axios/axios_visitortag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import * as keys from "../../../../../const/key/Key";
import axiosTags from "../../../../../axios/axios_tag";
import CameraUpdate from "./CameraUpdate/CameraUpdate";

class App extends Component{
  state = {
    data: [], branchId:'',branches:[],branchesTemp:[], selectedObj: null,isOpen: false,
  };
  componentWillMount(){
    this.getAllBranches();
  }
  getAllCameras = (branchId) =>  {

    this.setState({branchId: branchId !== null ? branchId : this.state.branchId, isOpen: false});
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitortags.get(apiConfig.IVCA_GET_ALL_CORPORATE_BRANCH_CAMERAS_BY_BRANCH({corporateId:this.props.usr_obj.corporateId, branchId: branchId !== null ? branchId : this.state.branchId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({data: response.data.visitorCameraList})
        }else{
          this.setState({data: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCameras(branchId);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  getAllBranches = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_WITH_BRANCHES, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        let branches = []; let branchesTemp = [];
        if (response.data.success) {
          let result = response.data.body;
          if (result.length !== 0) {
            result.map((resObj, index) => {
              if (resObj.corporateId === this.props.usr_obj.corporateId && resObj.branches.length !== 0) {
                branches.push({text: "ALL", value: 0, key: -1});
                resObj.branches.map((branch, index) => {
                  branches.push({
                    text: branch.name,
                    value: branch.branchId,
                    key: index
                  });
                  branchesTemp.push({
                    text: branch.name,
                    value: branch.branchId,
                    key: index
                  });
                });
              }
            });
          }
        }
        if(branches.length !== 0 ) this.getAllCameras(0);
        this.setState({branches,branchesTemp});
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranches();
        }else{
          this.props.spinnerHandler(false);
        }
      })
  };

  selectObjectHandler = (obj,condition) => {
    this.setState({selectedObj: obj, isOpen: condition});
  };

  render() {
    let {data,branchId,branches,branchesTemp,selectedObj,isOpen} = this.state;
    let rows = [];

    if(data.length !== 0){
      data.map((obj,index)=>{
        rows.push({
          cameraId: obj.cameraId,
          branchName: obj.branch.name,
          cameraPublicIp: obj.cameraPublicIp,
          rtspPort: obj.rtspPort,
          rtspUrl: obj.rtspUrl,
          username: obj.username,
          cameraSuffix: obj.cameraSuffix,
          addedBy: obj.addedBy,
          addedDate: common.convertDate(new Date(obj.addedDate)),
          updatedBy: obj.updatedBy,
          updatedDate: common.convertDate(new Date(obj.updatedDate)),
          visitorCameraStatus: obj.visitorCameraStatus,
          actions: <div key={index}>
            <SementicBtn circular icon='edit' onClick={() => this.selectObjectHandler(obj, true)} className={"more-update"}/>
          </div>,
        })
      })
    }


    let table_row = {columns: tableHeaders.ivcaAllCameraColumns , rows};
    return (
      <div className={"ivca-view-camera"}>

        {/* update camera */}
        {isOpen ? <CameraUpdate branches={branchesTemp} selectedObj={selectedObj} closeModalHandler={()=>this.setState({isOpen: false})} closeModal={()=>this.getAllCameras(null)}/> : null}

        <Card>
          <CardHeader>
            Filter Options
            {/*<div className={"align-right filter-btn"}>*/}
              {/*<SementicBtn onClick={this.filterHandler} circular icon='refresh'/>*/}
            {/*</div>*/}
          </CardHeader>
          <CardBody className=" paddingBottom">
            <div className="form-group paddingBottom">
              <Row>
                <Col md={3}>
                  <Dropdown
                    fluid selection
                    options={branches}
                    value={branchId}
                    placeholder={"Select branch"}
                    onChange={(event, {value}) => {
                      this.getAllCameras(value)
                    }}
                  />
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>

        <Card className="card margin0">
          <CardHeader>
            All Cameras
            <Download data={rows}/>
          </CardHeader>
          <CardBody>
            <Row>
              <Col lg="12">
                  <MDBDataTable
                    id={"qr-checkin-branch-visitors-reports-table"}
                    exportToCSV={true}
                    searching={true}
                    searchLabel={"Search"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={table_row}/>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

